export default __webpack_public_path__ + "static/account_review-8ae95a5a22870656b8e5c92be5033db7.png";